import React, {useEffect, useState} from 'react'
import { connect } from 'react-redux'
import {
  Container,
  Dimmer,
  Loader
} from 'semantic-ui-react'
import {
  Action,
  Dispatch
} from 'redux'
import qs from 'query-string'
import {DISPLAY_MODE, PAGES} from '../../constant'
import { AutoLoginParams } from '../../../types'
import './autoLogin.css'
import {push} from "react-router-redux";

type VimLoginProps = {
  location: { search: string }
  autoLogin: (params: AutoLoginParams) => void
}

type VimAppOpenStatus = {
  isAppOpen: boolean;
  /*
   * What triggered an app open.
   * - `manually`: The user opened on your app in the Hub.
   * - `auto_popup`: Your application code called the `autoPopup` api.
   * - `push_notification_clicked`: The user clicked on your app's push notification.
   */
  appOpenTrigger?: 'manually' | 'auto_popup' | 'push_notification_clicked';
  /*
   * What triggered an app close.
   * - `manually`: The user clicked either the close icon on the Vim Hub header or the heart icon, which resulted in closing both the Vim Hub and your application.
   * - `app_switch`: Another app was opened; Since only one app can be open at a time, opening another app will cause your app to close.
   * - `app_disabled`: The app status was changed to DISABLED while the app was in an open state. As a result, the app was closed and disabled.
   * - `app_request`: The code triggered the closeApp function exposed by the sdk.
   */
  appCloseTrigger?: 'manually' | 'app_switch' | 'app_disabled' | 'app_request';
};

function loadVimSdk() {
  // Suppose to use vim-os-js-browser instead, but can't because it requires modern NodeJS and React
  const VIM_SDK_URL = 'https://connect.getvim.com/vim-os-sdk/v2.x.x/vim-sdk.js';
  return new Promise((resolve, reject) => {
    if ((window as any).vimSdk) {
      resolve((window as any).vimSdk);
      return;
    }

    const script = document.createElement("script");
    script.type = "application/javascript";
    script.src = VIM_SDK_URL;
    script.async = true;
    document.body.appendChild(script);
    script.addEventListener("load", () => {
      const vimSdk = (window as any).vimSdk;
      if (!vimSdk) {
        reject(new Error('Vim SDK failed to load'));
        return;
      }

      resolve(vimSdk)
    });
    script.addEventListener("error", reject);
  }).then((vimSdk: any) => vimSdk.initializeVimSDK(VIM_SDK_URL));
}

function VimLogin(
  props: VimLoginProps
): JSX.Element {
  const { location, autoLogin: autoLoginAction } = props
  const params = qs.parse(location.search, { ignoreQueryPrefix: true }) as unknown as AutoLoginParams
const [vimOS, setVimOS] = useState<any>(undefined);

  useEffect(() => {
    (async () => {
      const vimOsSdk = await loadVimSdk();
      setVimOS(vimOsSdk);
      vimOsSdk.hub.setActivationStatus("ENABLED");
      const VIM_USER_SAW_APP_KEY = "vim-user-is-aware";
      if (!Boolean(localStorage.getItem(VIM_USER_SAW_APP_KEY))) {
        vimOsSdk.hub.notificationBadge.set(0);
        vimOsSdk.hub.appState.subscribe('appOpenStatus', (status: VimAppOpenStatus) => {
          if (status && status.isAppOpen === true) {
            localStorage.setItem(VIM_USER_SAW_APP_KEY, 'true');
            vimOsSdk.hub.notificationBadge.hide();
          }
        });
      }
      autoLoginAction(params);
    })();
  }, [])

  const mode = params.embedded && params.embedded === 'true'
    ? DISPLAY_MODE.EMBEDDED
    : DISPLAY_MODE.SMART

  if (mode === DISPLAY_MODE.EMBEDDED) {
    // if display mode is embedded, skip the friendly text
    return (
      <Container>
        <Dimmer active inverted>
          <Loader className="autologin-loader" size="big" />
        </Dimmer>
      </Container>
    )
  }

  return (
    <Container>
      <Dimmer active inverted>
        <Loader className="autologin-loader" size="big">
          <div className="autologin-header">Hang Tight!</div>
          <div className="autologin-content">We are logging you in.</div>
        </Loader>
      </Dimmer>
    </Container>
  )
}

export default connect(
  () => ({}),
  {
    autoLogin: () => (dispatch: Dispatch<Action>) => {
      dispatch(push(PAGES.VIM_COMING_SOON))
    }
  }
)(VimLogin)
